import style from './style.module.css'
export default function ({ children }){
    return (
        <div>
            <h1 className={style.title}>{ children }</h1>
            <hr className={style.line} />
        </div>
    )
}